import React from "react";
import Link from "next/link";
import SideMenu from "../ui/sideMenu";
import NovostiLinkLabel from "../novosti/NovostiLinkLabel";
const HomeBackHeader = () => {
  return (
    <div className="mobile:pb-[90px] relative max-w-[1280px] overflow-hidden mx-auto desktop:mt-[137.02px] mobile:mt-[115px] tablet:mt-[124px] flex justify-center">
      <img
        src="/samotna_klop.avif"
        alt="Naj spomin ne zbledi"
        className="mobile:hidden h-[605.27px] mobile:h-[257px] w-[1280px] object-cover"
      />
      <img
        src="/klop_naslovna.avif"
        alt="Naj spomin ne zbledi"
        className="mobile:flex hidden h-[257px] w-[1280px] object-cover"
      />
      <div className="h-[170px] smmobile:w-[135.58px] smmobile:h-[170px] w-[135.58px] left-[25.41px] smmobile:left-[14px] top-2 rounded-lg border border-[#D4D4D4] absolute mobile:flex hidden overflow-hidden shadow-custom-light-dark-banner bg-gradient-to-br from-[#FFFFFF] to-[#FFFFFF10] backdrop-blur-sm">
        <nav>
          <ul className="grid grid-cols-2 mobile:grid-cols-1 gap-[22px] p-4">
            <li>
              <HeaderHeadingTextMobile
                head={"OSMRTNICE"}
                index={"01."}
                id={1}
                endPoint={"/osmrtnice"}
              />
            </li>
            <li>
              <HeaderHeadingTextMobile
                head={"POGREBI"}
                index={"02."}
                id={2}
                endPoint={"/pogrebi/ljubljana"}
              />
            </li>
            <li style={{ visibility: "hidden" }}>
              <HeaderHeadingTextMobile
                head={"SPOMINSKA"}
                index={"03."}
                id={3}
                endPoint={"/osmrtnice"}
              />
            </li>
            {/* <li style={{ display: 'none' }}>
              <HeaderHeadingTextMobile
                head={"VSE ZA POGREBE"}
                index={"03."}
                id={4}
                endPoint={"/cvetlicarne"}
              />
            </li> */}
          </ul>
        </nav>
        {/* <div className="absolute top-4 left-4">
          <HeaderHeadingTextMobile
            head={"VSE ZA POGREBE"}
            index={"03."}
            id={4}
            endPoint={"/cvetlicarne"}
          />
        </div> */}
      </div>
      <div className="mobile:flex tablet:hidden desktop:hidden absolute top-[262px] left-[10px]">
        <Link
          href="/posodobitve"
          aria-label="Novosti"
          className="flex h-[34px] items-center rounded-full border-[3px] border-transparent bg-[linear-gradient(#DAE7F2,#DAE7F2),linear-gradient(135deg,#3F56B0_45%,#8A5BE0)] px-4 text-[16px] text-[#0A85C2] [background-clip:padding-box,border-box] [background-origin:padding-box,border-box]"
        >
          <NovostiLinkLabel />
        </Link>
      </div>
      <div className="mobile:flex tablet:hidden desktop:hidden absolute top-[260px] right-[10px]">
        <HeaderHeadingTextSpecial
          head={"VSE ZA POGREBE"}
          index={"03"}
          id={4}
          endPoint={"/lokalni"}
          // endPoint={"/cvetlicarne"}
        />
      </div>
      <nav className="justify-center absolute bottom-[44px] -mr-9 desktop:flex hidden">
        <ul className="flex">
          <li>
            <HeaderHeadingText
              head={"OSMRTNICE"}
              index={"01."}
              id={1}
              endPoint={"/osmrtnice"}
            />
          </li>
          <li>
            <HeaderHeadingText
              head={"POGREBI"}
              index={"02."}
              id={2}
              endPoint={"/pogrebi/ljubljana"}
            />
          </li>
          <li style={{ visibility: "hidden" }}>
            <HeaderHeadingText
              head={"SPOMINSKA"}
              index={"03."}
              id={3}
              endPoint={"/osmrtnice"}
            />
          </li>
          <li>
            <HeaderHeadingText
              head={"VSE ZA POGREBE"}
              index={"03."}
              id={4}
              endPoint={"/lokalni"}
            />
          </li>
        </ul>
      </nav>
      <nav className="justify-between absolute bottom-[70px] w-full max-w-[898.97px] tablet:flex hidden pl-[65px] pr-[50px]">
        <ul className="flex justify-between w-full">
          <li>
            <HeaderHeadingTextTablet
              head={"OSMRTNICE"}
              index={"01."}
              id={1}
              endPoint={"/osmrtnice"}
            />
          </li>
          <li>
            <HeaderHeadingTextTablet
              head={"POGREBI"}
              index={"02."}
              id={2}
              endPoint={"/pogrebi/ljubljana"}
            />
          </li>
          <li style={{ visibility: "hidden" }}>
            <HeaderHeadingTextTablet
              head={"SPOMINSKA"}
              index={"03."}
              id={3}
              endPoint={"/osmrtnice"}
            />
          </li>
          <li>
            <HeaderHeadingTextTablet
              head={"VSE ZA POGREBE"}
              index={"03."}
              id={4}
              endPoint={"/lokalni"}
            />
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default HomeBackHeader;

const HeaderHeadingText = ({ head, index, id, endPoint }) => {
  return (
    <div className="flex flex-row items-end w-[230px] ">
      <div className="w-[1.5px] h-[60px] bg-[#FFFFFF80] mr-[15px]" />
      <Link href={endPoint} className="">
        <div className="h-[75px]">
          <p
            className="flex"
            style={{
              marginTop: "2px",
              fontWeight: "200",
              textShadow: "1px 1px 2px #fff",
              color: "#7C7C7C",
              fontSize: "64px",
              lineHeight: "75px",
              fontVariationSettings: "'opsz' 64",
            }}
          >
            {index}
          </p>
        </div>
        <div className=" flex items-center h-[33px]">
          <p
            className="flex"
            style={{
              marginTop: "5px",
              color: "#DEDEDE",
              fontWeight: "500",
              fontSize: "28px",
              lineHeight: "32.81px",
              fontVariationSettings: "'opsz' 28",
            }}
          >
            {head}
          </p>
        </div>
      </Link>
    </div>
  );
};
const HeaderHeadingTextTablet = ({ head, index, id, endPoint }) => {
  return (
    <div className="flex flex-row items-end  ">
      <div className="w-[1.5px] h-[53px] bg-[#FFFFFF80] mr-[7.31px]" />
      <Link href={endPoint}>
        <div className="h-[47px]">
          <p
            className="flex"
            style={{
              marginTop: "2px",
              fontWeight: "200",
              textShadow: "1px 1px 2px #fff",
              color: "#7C7C7C",
              fontSize: "40px",
              lineHeight: "47px",
              fontVariationSettings: "'opsz' 40",
            }}
          >
            {index}
          </p>
        </div>
        <div className=" flex items-center h-[23px]">
          <p
            className="flex"
            style={{
              marginTop: "5px",
              color: "#DEDEDE",
              fontWeight: "500",
              fontSize: "20px",
              lineHeight: "23px",
              fontVariationSettings: "'opsz' 20",
            }}
          >
            {head}
          </p>
        </div>
      </Link>
    </div>
  );
};
const HeaderHeadingTextMobile = ({ head, index, id, endPoint }) => {
  return (
    <div className="flex flex-row w-[200px] items-end ">
      {/* <div className="flex flex-row w-[110px] items-end "> */}
      <div className="w-[1px] h-[57px] bg-[#C0C0C080]  " />
      <Link href={endPoint} className="ml-[6px]">
        <div className="h-[38px]">
          <p
            className="flex"
            style={{
              fontWeight: "200",
              textShadow: "1px 1px 2px #fff",
              color: "#A2A2A2",
              fontSize: "32px",
              lineHeight: "38px",
              fontVariationSettings: "'opsz' 32",
            }}
          >
            {index}
          </p>
        </div>
        <div className=" flex items-center h-[19px]">
          <p
            className="flex"
            style={{
              color: "#414141",
              fontWeight: "500",
              fontSize: "16px",
              lineHeight: "19px",
              fontVariationSettings: "'opsz' 16",
            }}
          >
            {head}
          </p>
        </div>
      </Link>
    </div>
  );
};

const HeaderHeadingTextSpecial = ({ head, index, id, endPoint }) => {
  return (
    <div className="flex flex-row w-[200px] items-center ">
      <Link
        href={endPoint}
        className="ml-[6px] flex flex-row-reverse items-center gap-2"
      >
        <div className="h-[38px] flex items-center gap-2">
          <div className="w-[1px] h-[47px] bg-[#C0C0C080]  " />
          <p
            className="flex"
            style={{
              fontWeight: "200",
              textShadow: "1px 1px 2px #fff",
              color: "#A2A2A2",
              fontSize: "32px",
              lineHeight: "38px",
              fontVariationSettings: "'opsz' 32",
            }}
          >
            {index}
          </p>
        </div>
        <div className=" flex items-center h-[19px]">
          <p
            className="flex"
            style={{
              color: "#A2A2A2",
              fontWeight: "500",
              fontSize: "16px",
              lineHeight: "19px",
              fontVariationSettings: "'opsz' 16",
            }}
          >
            {head}
          </p>
        </div>
      </Link>
    </div>
  );
};
